import React from "react";
import InputNumberField from "../inputNumberField/InputNumberField";
import { getProductSubCategory, isSystemProduct } from "../../utility";
import { toggleSwitchButtonConstants } from "../../../constants";

const OnlineQuantity = (props) => {
  const { currentStore, priceChartingProductInfo, productUrl = false } = props;
  const productMetaData = priceChartingProductInfo.productMetaData
    ? priceChartingProductInfo.productMetaData
    : priceChartingProductInfo;

  return (
    <div className="d-flex gap-3">
      {/* <span className="quantity-top-margin">Quantity:</span> */}
      <InputNumberField
        step={"1"}
        name="onlineQuantity"
        placeHolder="0"
        isHandleKeyDown={true}
        isConvertToDecimal={false}
        className={
          productUrl
            ? "instore-price-field-reduced-width"
            : "instore-price-field"
        }
        disabled={
          isSystemProduct(getProductSubCategory(productMetaData?.genre)) &&
          currentStore[
            toggleSwitchButtonConstants.IS_SERIAL_NUMBER_REQUIRED_INVENTORY
          ]
        }
        // className="add-inventory-quantity-field input-background" addTrade
      />
    </div>
  );
};

export default OnlineQuantity;
